import { render, staticRenderFns } from "./SecurityBank.vue?vue&type=template&id=5e821e3f&scoped=true&"
import script from "./SecurityBank.vue?vue&type=script&lang=js&"
export * from "./SecurityBank.vue?vue&type=script&lang=js&"
import style0 from "./SecurityBank.vue?vue&type=style&index=0&id=5e821e3f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e821e3f",
  null
  
)

component.options.__file = "SecurityBank.vue"
export default component.exports